<template>
  <div class="create-edit-ideas height-all">
    <div class="create-edit-ideas-title tl">
      {{ $$t("create.create_ideas") }}
    </div>
    <div
      class="create-edit-ideas-items-box flex1 height-0"
      v-if="renderData.ifRender"
    >
      <div class="create-edit-ideas-items">
        <QueryEmptyRetry
          :loading="renderData.initLoading"
          v-if="renderData.loadError || renderData.initLoading"
          @retry="
            () => {
              doRetry(true)
            }
          "
        ></QueryEmptyRetry>
        <PullTo
          itemIdField="id"
          v-else
          :datas="props.presetIdeas.concat(renderData.ideaDatas)"
          v-model:refreshing="renderData.refreshing"
          v-model:loadingMore="renderData.loadingMore"
          v-model:isLoading="renderData.isLoading"
          v-model:finished="renderData.finished"
          :disabledRefresh="false"
          :disabledLoadMore="false"
          @refresh="doRefresh"
          @loadMore="doLoadMore"
        >
          <template v-slot:default="slotProps">
            <div class="refer-music-item">
              <div
                class="create-edit-ideas-item pointer"
                :class="{
                  'create-edit-ideas-item-high': slotProps.item.is_top,
                  'create-edit-ideas-item-selected': props.idea?.includes(
                    slotProps.item.content
                  ),
                }"
                @click="
                  () => {
                    onClickItem(slotProps.item.content)
                  }
                "
              >
                <div
                  class="create-edit-ideas-item-hot"
                  v-show="slotProps.item.is_heat"
                >
                  {{ $$t("create.hot") }}
                </div>
                <p>
                  {{ slotProps.item.content }}
                </p>
              </div>
            </div>
          </template>
        </PullTo>
        <!-- <template v-for="(item, index) in 10" :key="index">
          <div
            class="create-edit-ideas-item pointer"
            @click="
              () => {
                onClickItem(
                  '2024 Olympics Make a song to cheer your country on at the 2024 Summer Olympics.'
                );
              }
            "
          >
            <div class="create-edit-ideas-item-hot">
              {{ $$t("create.hot") }}
            </div>
            <p>
              2024 Olympics Make a song to cheer your country on at the 2024
              Summer Olympics.
            </p>
          </div>
        </template> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { storeToRefs } from "pinia"

import useCreateEasyModeStore from "@/store/create/createEasyModeStore.js"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore.js"

const userDataStore = useUserDataStore()
const createLayoutStore = useCreateLayoutStore()
const createEasyModeStore = useCreateEasyModeStore()
const { createRenderType } = storeToRefs(createLayoutStore)

const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  defaultIdea: {
    type: String,
    default: "",
  },
  presetIdeas: {
    type: Array,
    default: () => [],
  },
  idea: {
    type: String,
    default: "",
  },
})
const emits = defineEmits(["clickItem", "initIdeaDatas"])

const renderData = reactive({
  ideaDatas: [],
  refreshing: false,
  loadingMore: false,
  isLoading: false,
  loadError: false,
  finished: false,
  filterParams: {
    query_type: 1,
  },
  initLoading: false,
  ifRender: true,
})

const onClickItem = (item) => {
  const globalProperties = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties
  emits("clickItem", item)
  globalProperties?.logClickEvent("create_basic_mode_ideas_txt", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    tab_stare: createLayoutStore.createModeGuideTabState
      ? "guide_switch"
      : "switch",
  })
}

const getQueryParams = () => {
  renderData.filterParams = {
    query_type: 1,
  }
  return renderData.filterParams
}

const doRefresh = (done, errodone) => {
  renderData.isLoading = true
  createEasyModeStore.refresh(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true
      renderData.isLoading = false
      renderData.loadError = false
      done(...args)
    },
    (...args) => {
      renderData.isLoading = false
      renderData.loadError = true
      errodone(...args)
    }
  )
}

const doLoadMore = (done, errodone) => {
  renderData.isLoading = true
  createEasyModeStore.loadMore(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true
      renderData.isLoading = false
      done(...args)
    },
    (...args) => {
      renderData.isLoading = false
      errodone(...args)
    }
  )
}

const doRetry = async (isRetry) => {
  if (isRetry && !(await userDataStore.checkLoginStatus())) {
    return
  }
  if (!isRetry) {
    renderData.initLoading = true
  }
  renderData.isLoading = true
  createEasyModeStore.init(
    getQueryParams(),
    (...args) => {
      renderData.isLoading = false
      renderData.finished = args[1] ?? true
      renderData.loadError = false
      renderData.initLoading = false
    },
    (...args) => {
      renderData.isLoading = false
      renderData.loadError = true
      renderData.initLoading = false
    }
  )
  true, isRetry
}

const reRender = () => {
  renderData.ifRender = false
  nextTick(() => {
    renderData.ifRender = true
  })
}

const initIdeasData = () => {
  //   let index = createEasyModeStore.datas_all?.indexOf(props.defaultIdea);
  // if (index > -1) {
  //   createEasyModeStore.datas_all.push(
  //     ...createEasyModeStore.datas_all?.splice(index, 1)
  //   );
  // }
  // renderData.ideaDatas = createEasyModeStore.datas_all;
  if (!createEasyModeStore.genresPromptmaps_all) return
  renderData.ideaDatas =
    createEasyModeStore.genresPromptmaps_all[
      createEasyModeStore.currentGenre
    ] ?? []
  emits("initIdeaDatas", renderData.ideaDatas)
  renderData.finished = !createEasyModeStore.loadmoreid_all
  nextTick(() => {
    reRender()
  })
}

const init = (isReinit) => {
  if (createEasyModeStore.genresPromptmaps_all && !isReinit) {
    // if (createEasyModeStore.datas_all?.length) {
    initIdeasData()
    renderData.initLoading = false
  } else {
    doRetry()
  }
}

watch(
  // () => createEasyModeStore.datas_all,
  () => createEasyModeStore.genresPromptmaps_all,
  (newVal) => {
    initIdeasData()
  }
)

watch(
  () => {
    return createEasyModeStore.currentGenre
  },
  () => {
    initIdeasData()
  }
)

watch(
  () => {
    return userDataStore.isLogin
  },
  () => {
    if (userDataStore.isLogin) {
      init()
    }
  }
)

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    nextTick().then(() => {
      init(true)
    })
  }
)
onMounted(() => {
  init(true)
})
</script>
<style lang="scss">
.create-edit-ideas {
  flex-direction: column;
  .create-edit-ideas-title {
    font-family: HarmonyOS Sans SC;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: none;
  }
  .create-edit-ideas-items-box {
    margin: 0 0 0 0;
    height: 100%;
    .create-edit-ideas-items {
      height: 100%;
      overflow-y: scroll;
    }
    .create-edit-ideas-item {
      padding: 12px 16px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
      background: rgba(255, 255, 255, 0.1);
      margin: 0 0 12px 0;
      border-radius: 12px;
      position: relative;
      &.create-edit-ideas-item-high {
        background: linear-gradient(
          100deg,
          rgba(121, 152, 255, 0.4) 0%,
          rgba(101, 175, 131, 0.4) 23%,
          rgba(202, 223, 159, 0.4) 49%,
          rgba(229, 132, 224, 0.4) 74%,
          rgba(183, 174, 255, 0.4) 100%
        );
      }
      &:first-child {
        margin: 2px 0 12px 0;
      }
      .create-edit-ideas-item-hot {
        position: absolute;
        top: -2px;
        right: 16px;
        width: 22px;
        height: 20px;
        background-image: url(@/assets/img/idea-hot-ico.png);
        background-size: 100% 100%;
        font-size: 8px;
        font-weight: bold;
        color: #000000;
        text-align: center;
        line-height: 20px;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        &.create-edit-ideas-item-high {
          background: linear-gradient(
            100deg,
            rgba(121, 152, 255, 0.6) 0%,
            rgba(101, 175, 131, 0.6) 23%,
            rgba(202, 223, 159, 0.6) 49%,
            rgba(229, 132, 224, 0.6) 74%,
            rgba(183, 174, 255, 0.6) 100%
          );
        }
      }
      &.create-edit-ideas-item-selected {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }
}
</style>
